export default [
  {
    path: '/newsDetail',
    name: 'newsDetail',
    component: () => import('@views/news/newsDetail.vue'),
    meta: {
      title: '消息详情'
    }
  },
  {
    path: '/appraise',
    name: 'appraise',
    component: () => import('@views/news/appraise.vue'),
    meta: {
      title: '投标消息-完工评价'
    }
  }, {
    path: '/midProjectEvaluation',
    name: 'midProjectEvaluation',
    component: () => import('@views/news/midProjectEvaluation.vue'),
    meta: {
      title: '投标消息-中期评价'
    }
  }, {
    path: '/evaluationResult',
    name: 'evaluationResult',
    component: () => import('@views/news/evaluationResult.vue'),
    meta: {
      title: '中期，完工评价结果'
    }
  }, {
    path: '/invitationJoin',
    name: 'invitationJoin',
    component: () => import('@views/news/invitationJoin.vue'),
    meta: {
      title: '邀请加入'
    }
  }, {
    path: '/applyJoin',
    name: 'applyJoin',
    component: () => import('@views/news/applyJoin.vue'),
    meta: {
      title: '申请加入'
    }
  },
  {
    path: '/changeDetails',
    name: 'changeDetails',
    component: () => import('@views/news/changeDetails.vue'),
    meta: {
      title: '变更详情'
    }
  },

  {
    path: '/information',
    name: 'information',
    component: () => import('@views/information/index.vue'),
    meta: {
      title: '消息—首页'
    }
  },
  {
    path: '/auditComplete',
    name: 'auditComplete',
    component: () => import('@views/information/auditComplete.vue'),
    meta: {
      title: '消息—完工审核'
    }
  },
  {
    path: '/evaluate',
    name: 'evaluate',
    component: () => import('@views/information/evaluate.vue'),
    meta: {
      title: '消息—完工评价'
    }
  },
  {
    path: '/evaluateDetail',
    name: 'evaluateDetail',
    component: () => import('@views/information/evaluateDetail.vue'),
    meta: {
      title: '消息—评价详情'
    }
  },
  {
    path: '/candidatesAnnouncement',
    name: 'candidatesAnnouncement',
    component: () => import('@views/information/candidatesAnnouncement.vue'),
    meta: {
      title: '消息—候选人公告'
    }
  },
  {
    path: '/isAccepted',
    name: 'isAccepted',
    component: () => import('@views/information/isAccepted.vue'),
    meta: {
      title: '消息—是否接标'
    }
  },
  {
    path: '/projectEvaluate',
    name: 'projectEvaluate',
    component: () => import('@views/information/projectEvaluate.vue'),
    meta: {
      title: '消息—项目待评价'
    }
  },
  {
    path: '/projectEvad',
    name: 'projectEvad',
    component: () => import('@views/information/projectEvad.vue'),
    meta: {
      title: '消息—项目已评价'
    }
  },
  {
    path: '/applyReject',
    name: 'applyReject',
    component: () => import('@views/information/applyReject.vue'),
    meta: {
      title: '消息—申请被驳回'
    }
  },
]
